import React, { useRef, useEffect } from 'react';

export default function Main({ handleNumber }) {

  const scriptRef = useRef(null);

  useEffect(() => {

    const script = document.createElement('script');
    script.src =
      'https://abhicashapp10.ameyoemerge.in:7443/ameyowebaccess/toolbar/js/ameyo-integration-v4_13.js';
    script.type = 'text/javascript';
    script.async = true;

    script.onload = () => {
      console.log('Ameyo script loaded', window);



      function customShowCrm(phone, additionalParams, requestId) {

        console.log("phoneno get karo", phone, "additionalParams", additionalParams, "requestId", requestId)
        const obj = {
          "phone": phone,
          "additionalParams": additionalParams,
          "requestId": requestId
        }
        handleNumber(obj)

      };


      if (window.ameyo?.integration?.registerCustomFunction) {
        console.log("windowsss", window.ameyo.integration)
        const customIntegration = {};
        customIntegration.showCrm = customShowCrm;
        window.ameyo.integration.registerCustomFunction(
          "showCrm",
          customIntegration
        );



        console.log("windowsss2222", window.ameyo.integration)
      }

      
    };

    document.body.appendChild(script);
    scriptRef.current = script;


    const crmOrigin = window.location.href;
    const ameyoBaseUrl = 'https://abhicashapp10.ameyoemerge.in:7443/';
    const iframeDiv = document.getElementById('ameyoIframeDiv');
    const iframeUrl = `${ameyoBaseUrl}ameyowebaccess/toolbarLogin-vl.htm?origin=${crmOrigin}`;
    iframeDiv.innerHTML = `<iframe allow="microphone *" height="600px" width="100%" id="ameyoIframe" src="${iframeUrl}" style="border-radius:20px"></iframe>`;

    return () => {

      if (scriptRef.current) {
        document.body.removeChild(scriptRef.current);
      }
    };
  }, []);




  return (
    <>
      <div
        style={{
          borderRadius: '20px',
          boxShadow: 'rgba(0, 0, 0, 0.2) 0px 4px 8px 0px',
        }}
      >
        <div id="ameyoIframeDiv" style={{ borderRadius: '20px' }}></div>
      </div>
      <div id="crmPage" style={{ marginTop: '20px' }}></div>




    </>
  );
}
